import MDBox from 'components/MDBox';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import MDTypography from 'components/MDTypography';

export const SsaProfileButton = styled(Button)`
  color: #1976d2;
  text-transform: none;
  border-color: #1976d2;

  &:hover {
    border: 1px solid #1565c0;
    background-color: rgba(25, 118, 210, 0.04);
  }
`;

export const SsaPasswordBox = styled(MDBox)`
  display: flex;
  max-width: 400px;
  padding: 16px;
  border-radius: 1;
  align-items: center;
  background-color: #e3f2fd;
  justify-content: space-between;
`;

export const PasswordTypography = styled(MDTypography)`
  ${(props) => (props?.error ? `color: #F44335` : '#1976d2')};
`;

export const SsaEmptyStateBox = styled(MDBox)`
  display: flex;
  padding: 16px;
  border-radius: 1;
  align-items: center;
  background-color: #e3f2fd;
  justify-content: space-between;
`;

export const NotesHistoryTypography = styled(Typography)`
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: 8px;
  color: #344767ad;
  white-space: pre-wrap;
`;
